import { render, staticRenderFns } from "./gallery-format-list.vue?vue&type=template&id=4fe5f1b0&"
import script from "./gallery-format-list.vue?vue&type=script&lang=ts&"
export * from "./gallery-format-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports